module.exports = __webpack_public_path__ + "img/apidays-live-hongkong-2021-agenda-826.30e67ce6.png";